import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

import loadimg from "../images/loader_wish.gif";

const TestProtectedRoute = ({ children, hasSubscription,randomTest }) => {

  const token = localStorage.getItem("token");
  const location = useLocation();
  const { slug } = useParams();

    const allowedSlugs = hasSubscription.test_user_slugs?.flat?.() || [];

    if (
      (hasSubscription.user_can_attend === false && 
       !allowedSlugs?.includes(slug))
    ) {

        return <Navigate to="/" replace state={{ from: location }} />;
    }

    if (
      Array.isArray(randomTest) &&
      randomTest.some(item => location.pathname === `/test/${item}`)
    ) {
      return (
        <Navigate
          to={`/${slug}`}
          replace
          state={{ from: location }}
        />
      );
    }

  return children;
};

export default TestProtectedRoute;
